import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-[#0a0a0a] px-5 py-16 text-white sm:px-8" data-id="element-18" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto w-full max-w-4xl" data-id="element-19" data-mp="plsk64cgd098">
        <h2 className="text-center text-3xl font-extrabold tracking-tight sm:text-4xl" data-id="element-20" data-mp="au1usomoiijf">
          🎁 You Also Get <span className="text-[#7c3aed]" data-id="element-21" data-mp="ft4qhigrrceq">5 Strategic Bonuses</span>
        </h2>
        <p className="mt-3 text-center text-sm text-neutral-400" data-id="element-22" data-mp="1tvi34yt1mlb">
          Included at no extra cost
        </p>

        <div className="mt-6 flex justify-center" data-id="element-23" data-mp="5x1m05yg31om">
          <p className="rounded-full border border-white/10 bg-[#141416] px-5 py-2.5 text-sm font-semibold text-neutral-300" data-id="element-24" data-mp="5tnnj8swjcmg">
            Real value:{' '}
            <span className="font-bold text-[#7c3aed] line-through" data-id="element-25" data-mp="3t1hkku9sfj0l">$328</span> — today
            included <span className="font-extrabold text-[#00c853]" data-id="element-26" data-mp="1mbjr531xkfvx">FREE</span>
          </p>
        </div>

        <div className="mt-10 grid gap-5 sm:grid-cols-2" data-id="element-27" data-mp="1r80e3txe8o7f">
          {bonuses.map((bonus, index) => <article key={bonus.number} className={`overflow-hidden rounded-2xl border border-white/10 bg-[#141416] ${index === bonuses.length - 1 ? 'sm:col-span-2 sm:mx-auto sm:max-w-md' : ''}`} data-id="element-28" data-mp="3id52z1tcov8o" data-mpi={index}>
              <img src={bonus.image} alt={bonus.imageAlt} className="h-44 w-full object-cover sm:h-48" loading="lazy" data-id="element-29" data-mp="3n4mxb70vbxko" />
              <div className="p-5" data-id="element-30" data-mp="2uh0ptnois8sj">
                <div className="flex items-center justify-between gap-3" data-id="element-31" data-mp="2ui25k5ghdjgl">
                  <p className="text-[11px] font-extrabold uppercase tracking-wider text-[#7c3aed]" data-id="element-32" data-mp="38hbjeyh7s1he">
                    {bonus.number}
                  </p>
                  <p className="text-[11px] font-bold" data-id="element-33" data-mp="nq1b6z5xn2sf">
                    <span className="text-[#7c3aed] line-through" data-id="element-34" data-mp="noqax9bp4d62">{bonus.oldPrice}</span>{' '}
                    <span className="text-[#00c853]" data-id="element-35" data-mp="iq558udod1a8">FREE</span>
                  </p>
                </div>
                <h3 className="mt-3 text-base font-extrabold" data-id="element-36" data-mp="3ciemd4oadwzm">{bonus.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-neutral-400" data-id="element-37" data-mp="3hgy9h8em9etk">
                  {bonus.description}
                </p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}